import { reportAPIFailure } from 'src/dataLayer/remoteData/rollbar/reportAPIErrors';
import {
  isReportingEnv,
  resetErrorMessages,
  setErrorMessages,
  setErrorMessagesFromBackend
} from 'src/dataLayer/remoteData/babbelAPI/createUser/errorHandlerHelpers';
import { handleExistingEmail } from 'src/dataLayer/remoteData/babbelAPI/createUser/handleExistingEmail';
import { RegistrationErrorHandler } from './types';

/*
Since we call a single registration endpoint on multiple nodes, we expect to receive certain error messages for
inputs which have not yet been rendered (shown later on different nodes).

This func returns true if there are no error messages for the currently rendered inputs, and false if there are.
We need it to return true so that we know we can continue to the next node in the flow.
If it returns false, we know not to continue in the flow and to display the relevant error message(s).
*/
export const registrationErrorHandler: RegistrationErrorHandler = (error, requestParams) => {
  const { payload, nodeInputs, errorInterface, trackingInfo, callback, verb, url } = requestParams;

  if (error.status !== 422 && isReportingEnv()) {
    const relevantRequestParams = {
      payload,
      nodeInputs,
      trackingInfo,
      verb,
      url
    };
    // TODO:: Remove this disable lint when reportAPIFailure has typings
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    reportAPIFailure(error, relevantRequestParams);
    return false;
  }

  // If we have no error messages but still an error from the backend, set a default error message for all nodeInputs
  // and return.
  // Otherwise, if there are error messages from the backend, clear the old ones before running the rest of the code.
  if (error.messages?.length === 0) {
    setErrorMessages(nodeInputs, errorInterface);
    return false;
  }
  resetErrorMessages(nodeInputs, errorInterface);


  // remove any error messages related to currently unrendered inputs
  const filteredErrorMessages = error.messages.filter((message) => nodeInputs.includes(message.attribute));

  // if there are no error messages for the rendered inputs, return true
  if (filteredErrorMessages.length === 0) return true;

  const { learn_language_alpha3 } = payload.user;

  // if the error is email taken, store the email and redirect to authentication
  if (filteredErrorMessages[0].attribute === 'email' && filteredErrorMessages[0].details[0] === 'taken') {
    handleExistingEmail(learn_language_alpha3, callback);
  } else {
    // otherwise, set the error message state and return false
    setErrorMessagesFromBackend(filteredErrorMessages, errorInterface, trackingInfo, learn_language_alpha3);
  }

  return false;
};
